import { render, staticRenderFns } from "./freight-list.vue?vue&type=template&id=79a4e37e&scoped=true&"
import script from "./freight-list.vue?vue&type=script&lang=js&"
export * from "./freight-list.vue?vue&type=script&lang=js&"
import style0 from "./freight-list.vue?vue&type=style&index=0&id=79a4e37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a4e37e",
  null
  
)

export default component.exports